import Room from "@sentrei/common/models/Room";

import {metadataCreate, metadataResponse, metadataUpdate} from "./Metadata";

export const roomBase = {
  name: "room",
  photo: null,
  description: "room",
  spaceId: "spaceId",
};

export const roomCreate: Room.Create = {
  ...roomBase,
  ...metadataCreate,
  memberCount: 0,
};

export const roomResponse: Room.Response = {
  ...roomBase,
  ...metadataResponse,
  memberCount: 0,
};

export const roomUpdate: Room.Update = {
  ...roomBase,
  ...metadataUpdate,
};
